import React, { useState } from 'react';
import { Mail, Send } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';
import './ContactModal.css';

const SUBJECTS = ['General inquiry', 'Bug report', 'Feature request', 'Account issue', 'Other'];

const ContactModal = ({ onClose }) => {
  const [form, setForm] = useState({ name: '', email: '', subject: 'General inquiry', message: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error('Please fill in all fields.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/auth/contact', form);
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cmodal-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="cmodal-panel">
        <div className="cmodal-header">
          <div className="cmodal-header-icon"><Mail size={16} /></div>
          <div>
            <h2 className="cmodal-title">Contact ApplAI</h2>
            <p className="cmodal-sub">Report an issue, suggest a feature, or just say hi</p>
          </div>
          <button className="cmodal-close" onClick={onClose}>✕</button>
        </div>

        {sent ? (
          <div className="cmodal-success">
            <div className="cmodal-success-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h3>Message sent!</h3>
            <p>We'll get back to you at <strong>{form.email}</strong> as soon as possible.</p>
            <button className="cmodal-done-btn" onClick={onClose}>Close</button>
          </div>
        ) : (
          <form className="cmodal-form" onSubmit={handleSubmit}>
            <div className="cmodal-row-2">
              <div className="cmodal-field">
                <label>Your Name</label>
                <input type="text" placeholder="Juan dela Cruz" value={form.name} onChange={e => set('name', e.target.value)} required />
              </div>
              <div className="cmodal-field">
                <label>Your Email</label>
                <input type="email" placeholder="you@email.com" value={form.email} onChange={e => set('email', e.target.value)} required />
              </div>
            </div>
            <div className="cmodal-field">
              <label>Subject</label>
              <select value={form.subject} onChange={e => set('subject', e.target.value)}>
                {SUBJECTS.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div className="cmodal-field">
              <label>Message</label>
              <textarea
                rows={5}
                placeholder="Describe your issue or question in detail..."
                value={form.message}
                onChange={e => set('message', e.target.value)}
                required
              />
            </div>
            <div className="cmodal-footer">
              <button type="button" className="cmodal-cancel" onClick={onClose}>Cancel</button>
              <button type="submit" className="cmodal-submit" disabled={loading}>
                {loading
                  ? <><span className="cmodal-spinner" /> Sending...</>
                  : <><Send size={13} /> Send Message</>
                }
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactModal;
